import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Zap } from "lucide-react";

export default function Mistakes() {
  const [state, setState] = useState({ mistakes: [], total: 0, preview_only: false });
  const load = () => api.get("/mistakes").then(({data}) => setState(data));
  useEffect(() => { load(); }, []);
  const mark = async (id, status) => { await api.post("/mistakes/review", { mistake_id: id, status }); toast.success("Updated"); load(); };
  return (
    <div className="space-y-6">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-display font-extrabold text-3xl text-slate-900">Mistake Bank</h1>
          <p className="text-slate-600 mt-1">Turn recurring mistakes into focused practice.</p>
        </div>
        {state.mistakes.length > 0 && !state.preview_only && (
          <Link to="/drills"><Button className="rounded-full bg-emerald-700 hover:bg-emerald-800" data-testid="mistakes-start-drill-btn"><Zap size={16} className="mr-1"/>Start today's drill</Button></Link>
        )}
      </header>
      {state.preview_only && (
        <div className="rle-card p-4 bg-amber-50 border-amber-200 text-amber-900 text-sm" data-testid="mistake-preview-banner">
          Preview only. Upgrade to Essential or Complete to see your full Mistake Bank. <Link to="/pricing" className="underline font-semibold">See pricing</Link>
        </div>
      )}
      {state.mistakes.length === 0 ? (
        <div className="rle-card p-8 text-slate-600">No mistakes yet. Complete a real-life mission to start building your Mistake Bank.</div>
      ) : (
        <div className="space-y-3">
          {state.mistakes.map((m) => (
            <div key={m.id} className="rle-card p-5" data-testid={`mistake-item-${m.id}`}>
              <div className="flex items-center justify-between">
                <span className="rle-eyebrow">{m.category?.replace("_"," ")}</span>
                <span className="text-xs text-slate-500 capitalize">{m.review_status}</span>
              </div>
              <div className="mt-2 text-sm"><span className="text-slate-500 mr-2">You said:</span><span className="text-slate-900 line-through decoration-red-300">{m.original_text}</span></div>
              <div className="mt-1 text-sm"><span className="text-slate-500 mr-2">Try:</span><span className="text-emerald-700 font-semibold">{m.corrected_text}</span></div>
              {m.explanation && <div className="mt-2 text-xs text-slate-600">{m.explanation}</div>}
              <div className="mt-3 flex gap-2">
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => mark(m.id, "reviewed")} data-testid={`mistake-reviewed-${m.id}`}>Mark reviewed</Button>
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => mark(m.id, "mastered")} data-testid={`mistake-mastered-${m.id}`}>Mastered</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
